import ScheduleServices from 'www/modules/Schedule/classes/ScheduleServices'
import { createClubLogic } from 'www/diagnostika.mobile.blocks/b-services-mobile/b-services-card/functions'

new ScheduleServices({
  selectorContainersSlots: '.b-card-services__calendar-slots',
  selectorContainerObserver: '[data-filter-target="services_list"]',
})

createClubLogic()
